import { useCallback, useEffect, useState } from "react";
import {
  MARITAL_STATUS_EVENT,
  isMarriedUser,
  syncMaritalStatus,
} from "../constants/maritalStatus";

export default function useUserMaritalStatus() {
  const userId = localStorage.getItem("user_id");
  const [maritalStatus, setMaritalStatus] = useState(
    () => localStorage.getItem("marital_status") || ""
  );
  const [loading, setLoading] = useState(Boolean(userId));

  const reload = useCallback(async () => {
    if (!userId) {
      setMaritalStatus("");
      setLoading(false);
      return "";
    }

    setLoading(true);
    try {
      const res = await fetch(`/api/profile/${userId}`);
      const data = await res.json();
      if (res.ok) {
        const status = data.marital_status || "";
        if (status) {
          setMaritalStatus(status);
          localStorage.setItem("marital_status", status);
          return status;
        }

        const cached = localStorage.getItem("marital_status") || "";
        if (cached) {
          setMaritalStatus(cached);
          return cached;
        }

        setMaritalStatus("");
        localStorage.removeItem("marital_status");
        return "";
      }
    } catch (err) {
      console.error("加载婚姻状况失败:", err);
    } finally {
      setLoading(false);
    }

    return "";
  }, [userId]);

  useEffect(() => {
    reload();

    const handleUpdate = (event) => {
      const next = event.detail?.maritalStatus;
      if (next !== undefined) {
        setMaritalStatus(next);
      } else {
        reload();
      }
    };

    window.addEventListener(MARITAL_STATUS_EVENT, handleUpdate);
    return () => window.removeEventListener(MARITAL_STATUS_EVENT, handleUpdate);
  }, [reload]);

  return {
    maritalStatus,
    loading,
    isMarried: isMarriedUser(maritalStatus),
    reload,
  };
}
